import client from "./client";
import { ApiEndpoints } from "./endpoints";

export const reboot = () => client.post(ApiEndpoints.MaintenanceReboot);
